import React from "react";
import { Table } from "antd";

const AccountsLeaderboard = ({ data }) => {
  const columns = [
    // { title: "#", dataIndex: "key", key: "key", width: 50 },
    { title: "User", dataIndex: "username", key: "username" },
    { title: "Rank", dataIndex: "rank", key: "rank" },
    {
      title: "Tournaments",
      dataIndex: "tournamentsPlayed",
      key: "tournamentsPlayed",
    },
    { title: "Score", dataIndex: "score", key: "score" },
    { title: "Games Ranked", dataIndex: "gameRank", key: "gameRank" },
  ];

  return (
    <div className="accounts-leaderboard glass-card">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered={false}
        className="accounts-table"
      />
    </div>
  );
};

export default AccountsLeaderboard;
